// @ts-nocheck
import dataReducer, { StoreDataActions } from "@store/Framework/Store/Data/DataReducer";
import pagesReducer, { StorePagesActions } from "@store/Framework/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducers = {
    data: dataReducer,
    pages: pagesReducer,
};

export type StoreActions = StorePagesActions | StoreDataActions;
export default combineReducers(storeReducers);
